import { render, staticRenderFns } from "./CreditorOrgInfo.vue?vue&type=template&id=1dae8546&scoped=true"
import script from "./CreditorOrgInfo.vue?vue&type=script&lang=ts"
export * from "./CreditorOrgInfo.vue?vue&type=script&lang=ts"
import style0 from "./CreditorOrgInfo.vue?vue&type=style&index=0&id=1dae8546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae8546",
  null
  
)

export default component.exports